import { FetchError } from '../errors/FetchError'
import { fetchWithAuthorization } from './fetch'

export const getAllParking = async (page, limit = 10, params) => {
  // eslint-disable-next-line
  const { search, property, condominium } = params;
  try {
    let url = `/parkingLot?condominium=${condominium}&page=${page}&limit=${limit}`
    const term = typeof search === 'string' ? search.trim() : ''
    if (term) url += `&search=${encodeURIComponent(term)}`

    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in getAllParking')
  }
}

export const removeParking = async (id) => {
  try {
    const data = await fetchWithAuthorization(
      `/parkingLot/${id}`,
      null,
      'DELETE'
    )
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in removeParking')
  }
}

export const createParking = async (condominium, obj) => {
  try {
    const url = `/parkingLot/${condominium}`
    const data = await fetchWithAuthorization(url, obj, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in createParking')
  }
}

export const getAllStalls = async (
  page,
  limit = 5,
  { parking, search, available }
) => {
  try {
    let url = `/parkingLot/${parking}?page=${page}&limit=${limit}`
    if (available === 0 || available === 1 || available === '0' || available === '1') {
      url += `&available=${available}`
    }
    const term = typeof search === 'string' ? search.trim() : ''
    if (term) url += `&search=${encodeURIComponent(term)}`
    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in getStalls')
  }
}

export const getPropertyStalls = async (
  page,
  limit = 5,
  { search, available }
) => {
  try {
    let url = `/parkingLot/property/me?page=${page}&limit=${limit}`
    if (search) url += `&search=${search}`
    if (available !== 'Todos' || available !== undefined) { url += `&available=${available}` }
    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in getStalls')
  }
}

export const updateStall = async (id, state) => {
  try {
    const data = await fetchWithAuthorization(
      `/parkingLot/property/${id}`,
      state,
      'PUT'
    )
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in updateStall')
  }
}

export const getStallDetails = async (id) => {
  try {
    const data = await fetchWithAuthorization(
      `/parkingLot/property/details/${id}`
    )
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in getStalls')
  }
}

export const generateAutoStalls = async (condominium, parking, quantity) => {
  try {
    const data = await fetchWithAuthorization(
      `/parkingLot/property/automatic/${condominium}/${parking}`,
      { quantity },
      'POST'
    )
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in generateStalls')
  }
}
export const updateParking = async (id, obj) => {
  try {
    const data = await fetchWithAuthorization(
      `/parkingLot/property/${id}`,
      obj,
      'PUT'
    )
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in updateParking')
  }
}

export const addStallManual = async (parking, property) => {
  try {
    const data = await fetchWithAuthorization(
      `/parkingLot/property/${parking}/${property}`,
      null,
      'POST'
    )
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error in updateParking')
  }
}
